var videoProtocolPlayer;

$(document).ready(()=>{

    let VideoPresPlayer;
    const videoPresURl = "https://player.vimeo.com/video/1059799223?h=8f5468a2f0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&autoplay=1";
    const videoPresThum = $("#video_thum");
    const videoPresiframe = $("#video_presentation");
    const videoPres = $('#video_presentation_overlay');
    const videoPresBtnInit = $('#video_presentation_play_init');
    const videoPresMenu = $('#video_presentation_left_menu');
    const videoProtocolCont = $("#procotol_video_container");
    const ProtocolsItems = $("#procotol_items_container");
    const videoProtocol = $("#video_protocol");



    videoPresMenu.on('click', (e) => {
        e.stopPropagation();
        console.log("click menu");
    });
    

    videoPres.on('click', (e) => {

        console.log("click overlay");
        videoPresiframe.attr('src', videoPresURl);
        videoPres.removeClass('display-init');
        videoPres.addClass('display-loading');

        videoPresiframe.on('load', e => {
            VideoPresPlayer = new Vimeo.Player(videoPresiframe[0]);
            
            videoPresThum.hide();
            videoPres.removeClass('display-loading');
            videoPres.addClass('display-play');
            videoPres.addClass('menu-close');

        })
        
    })

    $('#btn_float_dl').on('click', e => {
        e.stopPropagation();
    })

    videoProtocol.on('load', e => {
        videoProtocolPlayer = new Vimeo.Player(videoProtocol[0]);
    });


    new Swiper('#protocol_swiper', {
        slidesPerView: 1.2, spaceBetween: 12,
        breakpoints: { 
            480:{slidesPerView:2.2,spaceBetween:5}, 
            768:{slidesPerView:3.2,spaceBetween:5}, 
            1024:{slidesPerView:5,spaceBetween:10}, 
        },
    });

});


function openVideoProtocol(url, url_download, title = "", desc = "") 
{
    $("#procotol_items_container").hide();
    $("#procotol_video_container").show();
    $("#video_protocol").attr('src', url); 
    $('#btn_float_dl_protocol').attr('href', url_download);
    $('#protocols_description').text(desc);
}

function backProtocol()
{
    $("#procotol_items_container").show();
    $("#procotol_video_container").hide();
     $('#protocols_description').text(`Explore the foundation of our results-driven skincare with the Nouveau Visage NEWDERM professional treatment protocols. These advanced procedures are designed exclusively for aesthetic professionals and utilize proprietary blends of Exosomes, PDRN, and Biomimetic Peptides to deliver targeted results for various skin concerns.`);
    videoProtocolPlayer.pause();
}